import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { MAIN_NAVIGATION_CONFIG } from 'libs/design-system/src/lib/components/main-navigation/main-navigation.config';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import pt from '@angular/common/locales/pt';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { KeycloakCredentialsService, keycloakHttpInterceptorProvider, keyclockProviderFactory } from '@peca/keycloak';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { menu } from './core/menu';
import { SalesChannelService } from './core/services/sales-channel-autorization.service';

registerLocaleData(pt);

export const appConfig: ApplicationConfig = {
  providers: [
    KeycloakService,
    KeycloakCredentialsService,
    keycloakHttpInterceptorProvider,
    keyclockProviderFactory(environment.keycloak as KeycloakOptions),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    SalesChannelService,
    {
      provide: MAIN_NAVIGATION_CONFIG,
      useValue: { ...menu, production: environment.production },
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
  ],
};
